<template>
  <div class="d-flex">
    <div class="university-choosing">
      <h4 class="mt-3">Выбор вуза</h4>
      <b-card>
        <h5>Фильтрация</h5>
        <Filters :directions="directions" :cities="cities" @filter="onFilterChanged" />
      </b-card>
      <h5 class="my-3" v-if="partners.length">Вузы-партнеры</h5>
      <b-alert variant="primary" show v-else-if="loaded" class="mt-3">
        Для заданных фильтров нет подходящих вузов и направлений. Попробуйте изменить фильтр.
      </b-alert>
      <template v-if="loaded">
        <div
          v-for="(partner, index) of partners"
          class="mb-4"
          :key="index"
        >
          <UniversityCard
            :value="partner"
            :filter="filter"
          />
        </div>
      </template>
      <b-alert variant="primary" show v-else class="mt-3">
        <div class="text-center">
          <b-spinner variant="primary" />
        </div>
      </b-alert>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import RecommendationAPI from '@/api/recommendation'
import Filters from '@/components/common/university/Filters.vue'
import UniversityCard from '@/components/common/university/UniversityCard.vue'

export default {
  name: 'UniversityChoosing',
  components: {
    Filters,
    UniversityCard
  },
  provide() {
    return {
      currentYear: () => this.currentYear,
      windowWidth: () => this.windowWidth
    }
  },
  data() {
    return {
      currentYear: 0,
      windowWidth: 1280,
      directions: [],
      cities: [],
      partners: [],
      filter: {},
      defaultData: [],
      loaded: false
    }
  },
  async created() {
    const [directions, year] = await Promise.all([
      RecommendationAPI.getDirectionsByUniversity(),
      RecommendationAPI.getYear()
    ])
    this.currentYear = Number(year.data.year)
    this.defaultData = directions.data
    this.getCities(this.defaultData)
    this.getPartners(this.defaultData)
    this.getDirections(this.defaultData)
    this.windowWidth = window.innerWidth
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  methods: {
    getCities(data) {
      this.cities = (_.uniqBy(data, 'organization.city')).map((org) => org.organization.city).sort()
    },
    getDirections(data) {
      const groups = _.uniqBy(data.map((d) => d.educationDirection.directionGroup), 'id')
      for (const group of groups) {
        group.directions = data.filter((d) => d.educationDirection.directionGroup.id === group.id)
      }
      this.directions = groups
    },
    getPartners(data) {
      this.loaded = false
      const partners = _.uniqBy(data.map((p) => p.organization), 'id')
      for (const partner of partners) {
        partner.directions = data.filter((d) => d.organization.id === partner.id)
          .map((d) => {
            const lastYearData = this.currentYear
              ? d.directionMarkHistories.find((h) => h.year === this.currentYear)
              : null
            const lastYearMarkData = this.currentYear
              ? d.directionMarkHistories.find((h) => h.year === (this.currentYear - 1))
              : null
            return {
              ...d,
              quota: lastYearData ? lastYearData.quota : '-',
              minimalMark: lastYearMarkData ? lastYearMarkData.mark : '-'
            }
          })
      }
      this.partners = _.sortBy(partners, 'title')
      this.$nextTick(() => { this.loaded = true })
    },
    onFilterChanged(filters) {
      if (_.isEqual(this.filter, filters)) {
        return
      }
      this.filter = _.cloneDeep(filters)
      const paidData = filters.isPaid
        ? this.defaultData
        : this.defaultData.filter((d) => d.studyingForm !== 'contract')
      const subjectData = filters.subject.length
        ? paidData.filter((d) => filters
          .subject.length >= _.uniqBy(d.egeSubjects, 'directionUniversitySubject.order').length
          && filters.subject
            .filter((filter) => d.egeSubjects
              .find((s) => s.id === filter.subject.id
                && s.directionUniversitySubject.minimalMark <= filter.addMark))
            .length >= 3)
        : paidData
      const cityData = filters.city.length
        ? subjectData.filter((d) => filters.city.includes(d.organization.city))
        : subjectData
      const codes = filters.direction.map((d) => d.educationDirection.code)
      const directionData = codes.length
        ? subjectData.filter((d) => codes.includes(d.educationDirection.code))
        : subjectData
      const summaryData = codes.length
        ? cityData.filter((d) => codes.includes(d.educationDirection.code))
        : cityData
      this.getCities(directionData)
      this.getDirections(cityData)
      this.getPartners(summaryData)
    }
  }
}
</script>

<style scoped>
.university-choosing {
  width: min(1280px, 100%);
  margin: 10px auto;
}
</style>
